import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";

type FormSaveButtonProps = {
  onPress: () => void;
  isDirty: boolean;
  loading: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  label?: string;
};

const FormSaveButton = ({
  onPress,
  isDirty,
  loading,
  disabled,
  disabledTooltip,
  label = "Save",
}: FormSaveButtonProps) => {
  const isBlocked = !isDirty || !!disabled;
  const tooltipMessage = disabled ? disabledTooltip : "No changes to save";

  return (
    <Tooltip
      active={isBlocked}
      widthMode="maxWidthXSm"
      on={(props) => (
        <Button
          {...props}
          variant="primary"
          onPress={onPress}
          loading={loading}
          ariaDisabled={isBlocked}
        >
          {label}
        </Button>
      )}
    >
      {tooltipMessage}
    </Tooltip>
  );
};

export default FormSaveButton;
